import {createReducer, on} from '@ngrx/store';
import {Bundle} from '@sportngin/se-commerce-sdk/models/clare';
import {ProductManagementErrorInterface} from '../../../../../error/error-handling/product-management-error';
import {CatalogSummary} from '../../../../../models/clare';
import {CreateBundleActions} from './create-bundle.actions';

export const CREATE_BUNDLE_FEATURE_KEY = 'Create Bundle Feature';

export interface CreateBundleState {
  catalogs: CatalogSummary[];
  catalogsLoading: boolean;
  loading: boolean;
  error: ProductManagementErrorInterface | undefined;
  bundleId: string | undefined;
  organizationName: string | undefined;
  bundles: Bundle[];
}

export const initialCreateBundleState: CreateBundleState = {
  catalogs: [],
  catalogsLoading: false,
  loading: false,
  error: undefined,
  bundleId: undefined,
  organizationName: undefined,
  bundles: [],
};

export const createBundleReducer = createReducer(
  initialCreateBundleState,
  on(CreateBundleActions.loadCatalogs, state => ({
    ...state,
    catalogs: [],
    catalogsLoading: true,
  })),
  on(CreateBundleActions.loadCatalogsSuccess, (state, {catalogs}) => ({
    ...state,
    catalogs,
    catalogsLoading: false,
  })),
  on(CreateBundleActions.loadCatalogsFailure, state => ({
    ...state,
    catalogs: [],
    catalogsLoading: false,
  })),
  on(CreateBundleActions.createBundle, (state): CreateBundleState => ({
    ...state,
    loading: true,
    error: undefined,
    bundleId: undefined,
  })),
  on(CreateBundleActions.createBundleSuccess, (state, {bundleId}): CreateBundleState => ({
    ...state,
    loading: false,
    error: undefined,
    bundleId,
  })),
  on(CreateBundleActions.createBundleFailed, (state, {error}): CreateBundleState => ({
    ...state,
    loading: false,
    error,
  })),
  on(CreateBundleActions.loadBundlesByCatalogId, CreateBundleActions.loadAllBundles, (state): CreateBundleState => ({
    ...state,
    loading: true,
    error: undefined,
  })),
  on(CreateBundleActions.loadBundlesByCatalogIdSuccess, (state, {bundles}): CreateBundleState => ({
    ...state,
    loading: false,
    bundles,
  })),
  on(CreateBundleActions.loadBundlesByCatalogIdFailed, (state, {error}): CreateBundleState => ({
    ...state,
    loading: false,
    error,
  })),
  on(CreateBundleActions.loadAllBundlesSuccess, (state, {bundles}): CreateBundleState => ({
    ...state,
    loading: false,
    bundles,
  })),
  on(CreateBundleActions.loadAllBundlesFailed, (state, {error}): CreateBundleState => ({
    ...state,
    error,
    loading: false,
  }))
);

export const getLoading = (state: CreateBundleState) => state.loading;
export const getCatalogs = (state: CreateBundleState) => state.catalogs;
export const getCatalogsLoading = (state: CreateBundleState) => state.catalogsLoading;
export const getError = (state: CreateBundleState) => state.error;
export const getBundleId = (state: CreateBundleState) => state.bundleId;
export const getOrganizationName = (state: CreateBundleState) => state.organizationName;
export const getBundles = (state: CreateBundleState) => state.bundles;
export const getBundleById = (state: CreateBundleState, bundleId: number) =>
  state.bundles.find(bundle => bundle.id === bundleId) ?? undefined;
